import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {DataQueryService} from '../data-query.service';
import {DataQueryInformation} from '../data-query-information';
import {Subscription} from 'rxjs';
import {FieldAutofillOption} from './field-autofill-option';

@Component({
	selector: 'field-search',
	templateUrl: './field-search.component.html',
	styleUrls: ['./field-search.component.css']
})
export class FieldSearchComponent implements OnInit, OnDestroy {

	// Interface Properties
	@Output() search = new EventEmitter<string>();

	// Properties
	searchString = '';
	previousSearchString = '';
	information: DataQueryInformation;
	subscriptions: Subscription[] = [];
	autofills: FieldAutofillOption[] = [];

	// Class Functions
	constructor(
		private dataQueryService: DataQueryService
	) { }

	// Event Functions
	ngOnInit() {
		this.subscriptions.push(
			this.dataQueryService.observableInformationStream$.subscribe(information => {
				this.information = information;
			})
		);
	}

	ngOnDestroy() {
		this.subscriptions.forEach(subscription => {
			subscription.unsubscribe();
		});
	}

	sendSearch() {
		// PRE: the user presses enter in the text field or unfocuses the input
		// POST: emits the search and clears the autofill
		setTimeout(() => {	// We do this in a set timeout in case an option is clicked
			this.search.emit(this.searchString);
			this.autofills = [];
		}, 100);
	}

	// Methods
	getAutofills() {
		// POST: obtains the autofills for the user
		if (this.previousSearchString != this.searchString) {
			this.previousSearchString = this.searchString;
			this.autofills = this.information.getAutofillOptions(this.searchString);
		}
	}
}
